import { alpha } from '@mui/material/styles';

// ==============================|| OVERRIDES - TABLE HEAD ||============================== //

export default function TableHead(theme) {
  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.18 : 0.09),
          borderTop: '1px solid',
          borderTopColor: alpha(theme.palette.text.primary, 0.16),
          borderBottom: '2px solid',
          borderBottomColor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.45 : 0.3)
        }
      }
    }
  };
}
